module.exports = __webpack_public_path__ + "ceb85968afc1912b96aee3e937e6e670.pdf";